import React from "react";
import { CreateAccountModal } from "../../modals/CreateAccountModal";
import { IncorrectDataModal } from "../../modals/IncorrectDataModal";
import { PasswordLastChanceModal } from "../../modals/PasswordLastChanceModal";
import { PasswordBlockedModal } from "../../modals/PasswordBlockedModal";
import { AccountUnderReviewModal } from "../../modals/AccountUnderReviewModal";
import { FirstAccessModal } from "../../modals/FirstAccessModal";
import { GenericErrorModal } from "../../modals/GenericErrorModal";
import { PreRegisterModal } from "../../modals/PreRegisterModal";
import { PreRedoRegisterModal } from "../../modals/PreRedoRegisterModal";
import { BlockAkamaiUserErrorModal } from "../../modals/BlockAkamaiUserErrorModal";
import { BlockAkamaiPassErrorModal } from "../../modals/BlockAkamaiPassErrorModal";

export const ModalWrapper = () => {
    return (
      <>
        <CreateAccountModal />
        <IncorrectDataModal />
        <PasswordLastChanceModal />
        <PasswordBlockedModal />
        <AccountUnderReviewModal />
        <FirstAccessModal />
        <GenericErrorModal />
        <PreRegisterModal />
        <PreRedoRegisterModal />
        <BlockAkamaiUserErrorModal />
        <BlockAkamaiPassErrorModal />
      </>
    );
};
